import {
  Alert,
  Button,
  Card,
  Col,
  Image,
  notification,
  Row,
  Tooltip,
  Typography,
} from "antd";
import logo1 from "assets/vendors/gif/arrange-file.gif";
import { useAuth } from "authentication";
import { setProgram } from "data/actions/Common";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import AppConfig from "utils/Config";
import { ClientSelectedProgram } from "utils/Constant";
import { setCookieValue } from "utils/Storage";
import { getDefaultRoute } from "utils/permissions";

const ProgramSelect = () => {
  const { userSignOut } = useAuth();
  const { Title } = Typography;
  const dispatch = useDispatch();
  const { authUser } = useSelector(({ auth }) => auth);
  const [selected, setSelected] = useState("");
  const [activeProgram, setActiveProgram] = useState();
  const history = useHistory();

  /**
   * @function handleProgram
   * @description Handles the selected program
   */
  const handleProgram = async (item) => {
    setActiveProgram(item);
    notification.info({
      message: "Program Selected",
      description: `You have selected ${item}`,
    });
    setSelected(item);
    setCookieValue(ClientSelectedProgram, item);
    await dispatch(setProgram(selected));
  };

  // =============================
  // =========================== ==

  /**
   * @function navigateProgram
   * @description Navigates to the selected program using centralized permission system
   */
  const navigateProgram = async () => {
    // Use centralized permission system to get default route
    const defaultRoute = getDefaultRoute(authUser, activeProgram);

    setTimeout(() => {
      history.push(defaultRoute);
    }, 200);
  };
  // =============================

  /**
   * @function programs
   * @description Gets the programs from the user object
   */
  // create an array of programs with a default value of "General" and if the user has a program, add it to the array

  const programs = [];

  authUser?.programs_roles?.map((obj) => {
    return programs.push(obj?.programs);
  });
  // =============================

  return (
    <div className="program_select_container">
      <div className="gx-container">
        <section>
          <div className="header_img">
            <Image
              src={AppConfig.logo}
              alt={AppConfig.appName}
              className="gx-mb-2"
              preview={false}
              width={120}
            />
            <Title level={4}>Select Default</Title>
          </div>
          <section className="flex gx-flex-column gx-mt-lg-5 gx-mt-3">
            <Card style={{ zIndex: 10 }}>
              <Row className="dropdown gx-mb-4 gx-mx-1 gx-p-3 gx-gap-2 flex justify-center 2xl:max-h-[45dvh] h-[40dvh]">
                {programs.map((item, i) => {
                  return (
                    <Col
                      xl={4}
                      lg={6}
                      md={8}
                      sm={24}
                      key={i}
                      className="flex items-center justify-center gx-mb-3 gx-p-0 gx-w-100"
                      onClick={() => handleProgram(item)}
                    >
                      <div
                        className={`dropdown-item items-center justify-center gx-w-75 shadow ${
                          activeProgram === item ? "active" : "inactive"
                        }`}
                      >
                        <img src={logo1} alt={item} width="100" />
                        <Tooltip title={item}>
                          <span className="gx-text-capitalize">
                            {item?.length > 20
                              ? `${item?.substring(0, 20)}...`
                              : item}
                          </span>
                        </Tooltip>
                      </div>
                    </Col>
                  );
                })}
              </Row>

              <div className="flex justify-center">
                <Button className="gx-width-175" onClick={userSignOut}>
                  Back
                </Button>
                <Button
                  disabled={!selected}
                  type="primary"
                  onClick={navigateProgram}
                  className="gx-width-175"
                >
                  Continue
                </Button>
              </div>

              <div className="gx-mb-2 md:block hidden">
                {selected && (
                  <Alert
                    message={
                      <>
                        Several measures have been instituted by the Federal
                        Government of Nigeria through the{" "}
                        <strong>{selected}</strong>
                      </>
                    }
                    description="eN-LIS Project Team together with the Federal Ministry of Health to curtail the spread"
                    type="info"
                    showIcon
                    className="flex justify-center items-center"
                  />
                )}
              </div>
            </Card>
          </section>
        </section>
        <div className="footer_img">
          <img src={AppConfig.spiral} alt="spiral design" />
        </div>
      </div>
    </div>
  );
};

export default ProgramSelect;
